import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { BoardNodes, BoardNodesResponse } from 'types/BoardNode';
import { useBatchUpdateOperations } from 'hooks/batchOperations';

export function useReorderBoardNodes(boardID: string | null | undefined) {
  const { mutateAsync: batchUpdateBoardNodes } = useBatchUpdateOperations();
  const queryClient = useQueryClient();

  const makeUpdate = (variables: BoardNodes[]) => {
    const updates = variables.map((boardNode, index) => {
      return {
        type: SPARK_RESOURCE_TYPES.BOARD_NODES,
        attributes: { id: boardNode.id, sortOrder: index + 1 },
      };
    });

    return batchUpdateBoardNodes(updates);
  };

  return useMutation('batchUpdateBoardNodes', makeUpdate, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to get Board Nodes: ${error.message}`);
      }
    },
    onMutate: (data) => {
      queryClient.setQueryData<BoardNodesResponse>(
        [SPARK_RESOURCE_TYPES.BOARD_NODES, boardID],
        (oldValues) => {
          const updatedSortORder = data.map((item, index) => ({
            ...item,
            attributes: { ...item.attributes, sortOrder: index + 1 },
          }));

          return { ...oldValues, data: updatedSortORder || [] };
        }
      );
    },
  });
}
